/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedReportingRouteImport } from './routes/_authed.reporting'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedTeamRouteImport } from './routes/_authed.team'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportingRoute = AuthedReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamRoute = AuthedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthedRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/reporting': typeof AuthedReportingRoute
  '/settings': typeof AuthedSettingsRoute
  '/team': typeof AuthedTeamRoute
  '/invite/$token': typeof InviteTokenRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/reporting': typeof AuthedReportingRoute
  '/settings': typeof AuthedSettingsRoute
  '/team': typeof AuthedTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AuthedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/_authed/reporting': typeof AuthedReportingRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/team': typeof AuthedTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_authed/': typeof AuthedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/signup'
    | '/reporting'
    | '/settings'
    | '/team'
    | '/invite/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/signup'
    | '/reporting'
    | '/settings'
    | '/team'
    | '/invite/$token'
    | '/'
  id:
    | '__root__'
    | '/_authed'
    | '/onboarding'
    | '/signup'
    | '/_authed/reporting'
    | '/_authed/settings'
    | '/_authed/team'
    | '/invite/$token'
    | '/_authed/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  SignupRoute: typeof SignupRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reporting': {
      id: '/_authed/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AuthedReportingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/team': {
      id: '/_authed/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthedTeamRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthedRouteChildren {
  AuthedReportingRoute: typeof AuthedReportingRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTeamRoute: typeof AuthedTeamRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedReportingRoute: AuthedReportingRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTeamRoute: AuthedTeamRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  SignupRoute: SignupRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
